import each from 'lodash-es/each';
import getSelectedVariant from './getSelectedVariant';
import { getProductJson } from '../../core/productInfo';

const hideZeroPriceSizesInCurrentColor = () => {
  const productJson = getProductJson();
  const selectedVariant = getSelectedVariant(productJson);

  // Skip execution if we're in QuickView US experience (fetch path, NOT FastSimon) and product is not GIVEX
  const quickViewModal = document.querySelector('#QuickView.Modal--open');
  const isBuiltWithFastSimon = quickViewModal?.getAttribute('data-built-with-fastsimon') === 'true';

  if (isBuiltWithFastSimon) {
    return;
  }

  if (!selectedVariant) {
    console.log('hideZeroPriceSizesInCurrentColor - no selected varaint');
    return;
  }

  const currentColor = selectedVariant.options[0];
  const variantsWithCurrentColor = productJson.variants.filter((item) => {
    return item.options[0] === currentColor;
  });

  // if selected variant is zero price, select the first available
  if (selectedVariant.price === 0) {
    let firstAvailbleVariant;

    for (let i = 0; i < variantsWithCurrentColor.length; i++) {
      const variant = variantsWithCurrentColor[i];

      if (variant.price > 0) {
        firstAvailbleVariant = variant;
        break;
      }
    }

    if (firstAvailbleVariant) {
      setTimeout(() => {
        const element = document.querySelector(
          `[data-size-variant-selector][data-value="${firstAvailbleVariant.option2}"]`,
        );
        if (element) {
          element.click();
        }
      });
    }
  }

  document.querySelectorAll('[data-size-variant-selector]').forEach((el) => (el.style.display = 'block'));
  document.querySelectorAll('[data-secondary-size-variant-selector]').forEach((el) => (el.style.display = 'block'));
  document
    .querySelectorAll('select[data-size-variant-selector] option')
    .forEach((el) => el.removeAttribute('disabled'));

  each(variantsWithCurrentColor, (variant) => {
    if (variant.price > 0) {
      return;
    }

    const sizeVariantElements = document.querySelectorAll(
      `[data-size-variant-selector][data-value="${variant.option2}"]`,
    );
    sizeVariantElements.forEach((el) => (el.style.display = 'none'));

    const secondarySizeVariantElements = document.querySelectorAll(
      `[data-secondary-size-variant-selector][data-value="${variant.option2}"]`,
    );
    secondarySizeVariantElements.forEach((el) => (el.style.display = 'none'));

    const optionElements = document.querySelectorAll(
      `select[data-size-variant-selector] option[value="${variant.option2}"]`,
    );
    optionElements.forEach((el) => el.setAttribute('disabled', true));
  });

  // Also disable the unavailable options in the sticky buy
  // Wait for the main options to finish updating first
  setTimeout(() => {
    document.querySelectorAll('[data-custom-variant-selector][data-size-variant-selector]').forEach((el) => {
      if (el.classList.contains('ProductOption__variant--unavailable')) {
        const val = el.getAttribute('data-value');

        const optionElements = document.querySelectorAll(`select[data-size-variant-selector] option[value="${val}"]`);
        optionElements.forEach((optEl) => optEl.setAttribute('disabled', true));
      }
    });

    // Refreshing the select options, if applicable
    const selectElements = document.querySelectorAll('select[data-size-variant-selector]');
    selectElements.forEach((selectEl) => {
      const event = new Event('change');
      selectEl.dispatchEvent(event);
    });
  }, 1);
};

export default hideZeroPriceSizesInCurrentColor;
